import { Checkbox } from "@rmwc/checkbox";
import React from "react";

export interface ShowItemizedEstimateCheckboxPropsT {
  checked: boolean;
  setChecked: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ShowItemizedEstimateCheckbox: React.FC<ShowItemizedEstimateCheckboxPropsT> = ({ checked, setChecked }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", marginRight: "1rem" }}>
      <span
        style={{
          textAlign: "right",
          fontSize: "13px",
          lineHeight: "1.2",
          marginRight: "3px",
        }}
      >
        Show Detail
      </span>

      <Checkbox style={{ fontSize: "10px" }} checked={checked} onChange={() => setChecked(!checked)}></Checkbox>
    </div>
  );
};
